module.exports = __webpack_public_path__ + "static/img/award4_active.f71af32.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/index/award4_active.png
// module id = RenP
// module chunks = 7